
/* eslint-disable no-unused-expressions */

const helpers = (props) => {
  let bothSliderMoved = false;
  let sliderOneMoved = false;
  let sliderTwoMoved = false;
  let results = {};
  let fieldsEqual = [
    { name: '_templatename', value: 'Offer Detail' },
    { name: 'offerCategories', value: props?.offerCategoryId },
  ];

  //in case of or
  if (props?.allFilters?.selectedLocationsIDForGraphGql.length > 0) {
    fieldsEqual.push({
      name: 'emirateIds',
      value: `in:${props?.allFilters?.selectedLocationsIDForGraphGql}`,
    });
  }
  if (props?.allFilters?.selectedCuisineIDForGraphGql.length > 0) {
    fieldsEqual.push({
      name: 'offerCusines',
      value: `in:${props?.allFilters?.selectedCuisineIDForGraphGql}`,
    });
  }
  if (props?.allFilters?.selectedOfferTagsIDForGraphGql.length > 0) {
    fieldsEqual.push({
      name: 'offerTags',
      value: `in:${props?.allFilters?.selectedOfferTagsIDForGraphGql}`,
    });
  }
  //in case of end

  if (props?.allFilters?.selectedCardsIDForGraphGql.length > 0) {
    fieldsEqual.push({
      name: 'eligibleCards',
      value: `in:${props?.allFilters?.selectedCardsIDForGraphGql}`,
    });
  }

  let discountFrom = props?.allFilters?.discountFilter?.from;
  let discountTo = props?.allFilters?.discountFilter?.to;

  if (!!discountFrom) {
    if (discountFrom !== props?.allFilters?.minDiscount) {
      fieldsEqual.push({
        name: 'discountPercentage',
        value: `>:${discountFrom}`,
      });
      sliderOneMoved = true;
    }
  }

  if (!!discountFrom && !!discountTo) {
    if (discountTo !== props?.allFilters?.maxDiscount) {
      fieldsEqual.push({
        name: 'discountPercentage',
        value: `<:${discountTo}`,
      });
      sliderTwoMoved = true;
    }
  }
  bothSliderMoved = sliderOneMoved && sliderTwoMoved;

  fieldsEqual.push({
    name: 'validitystart',
    value: `<:${new Date().toISOString()}`, //we start from today date format:2021-12-31T16:00:00Z
  });

  fieldsEqual.push({
    name: 'validityEnd',
    value: `>:${new Date().toISOString()}`, //date format:2021-12-31T16:00:00Z
  });

  let mobileResults = {
    index: props?.indexName,
    language: props?.language,
    fieldsEqual: fieldsEqual,
    after: `0`,
    first: null,
  };
  let DesktopResults = {
    index: props?.indexName,
    language: props?.language,
    first: props?.pagination?.itemsPerPage,
    fieldsEqual: fieldsEqual,
    after: `${
      !!props?.pagination?.currentPage && !!props?.pagination?.itemsPerPage
        ? `${props?.pagination?.itemsPerPage * (props?.pagination?.currentPage - 1)}`
        : '0'
    }`,
  };

  if (props?.isMobile) {
    results = mobileResults; //in mobile results we dont have pagination so we remove the first and after
  } else {
    results = DesktopResults;
  }

  if (props?.allFilters?.sortBy !== '') {
    results.sorting = `${props?.allFilters?.sortBy}`;
  }

  //on filtering
  if (props?.setFilterVariable !== undefined) {
    if (props?.allFilters?.keyword !== '') {
      results.keyword = `${props?.allFilters?.keyword}`;
    } else {
      results.keyword = '';
    }
    props.setFilterVariable(results);
  }
  //on keyword change [handleKeywordChange]
  if (props?.getSearchSuggestions !== undefined) {
    results.sorting = ``; // we dont need sorting when we click search
    if (props?.keyword !== '') {
      results.keyword = `${props?.keyword}`;
    } else {
      results.keyword = '';
    }
    props.getSearchSuggestions({
      variables: {
        ...results,
      },
    });
  }
  //when we click on search [handleKeywordClick]
  if (props?.refetch !== undefined) {
    props.setAllFilters((prev) => {
      return {
        ...prev,
        reRender: !prev.reRender,
        keyword: props?.keyword, //get search keyword to force get the latest state
      };
    });
  }

  let sliderFilterLine = 0;
  if (bothSliderMoved) {
    sliderFilterLine = 1;
  }

  props?.setNumberOfFilters(results?.fieldsEqual?.length - 4 - sliderFilterLine);
};

export default helpers;
